<template lang="pug">
  .wrap
    .main
      .main-inner
        .main-header
          h2 市況分析の管理
          p
            | 市況分析の検索条件は最大50件まで登録することができます。<br />
            | 保存した市況分析の検索条件が上限を超えた場合「削除する」にて既存の条件を整理してご利用ください。
        .blankslate(v-if="!index.length")
          h1 市況分析の検索条件が登録されていません。

        AggJobSearchCondition(v-for="(v, i) in index", :condition="v", :index="i", :key="v.id")
</template>

<script>
  import { mapGetters } from 'vuex'
  import AggJobSearchCondition from './parts/AggJobSearchCondition'

  export default {
    components: { AggJobSearchCondition },
    async asyncData ({ store }) {
      await store.dispatch('aggJobSearchCondition/fetchIndex')
    },
    computed: {
      ...mapGetters({
        index: 'aggJobSearchCondition/humanizedIndex',
      }),
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/AggJobSearchConditions.vue